// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.html-container {
  font-family: Arial, sans-serif;
  position: relative;
  overflow: hidden;
}

.decorative-boxes .box:hover {
  transform: scale(1.1);
  cursor: pointer;
}

h1 {
  margin: 0;
  padding: 0;
}

p {
  margin: 0;
  padding: 0;
  line-height: 1.6;
}
`, "",{"version":3,"sources":["webpack://./functions/html-design/styles.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB","sourcesContent":[".html-container {\n  font-family: Arial, sans-serif;\n  position: relative;\n  overflow: hidden;\n}\n\n.decorative-boxes .box:hover {\n  transform: scale(1.1);\n  cursor: pointer;\n}\n\nh1 {\n  margin: 0;\n  padding: 0;\n}\n\np {\n  margin: 0;\n  padding: 0;\n  line-height: 1.6;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
